import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { projectImages } from './projectImages';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUpRightFromSquare, faCircleLeft } from '@fortawesome/free-solid-svg-icons';
import { motion } from 'framer-motion';
import { containerStagger, fadeUpOnView } from '../../animations/textAnimation';
import { NavLink } from 'react-router-dom';
import './work.css';

export default function WorkChild() {
  const { projectId } = useParams();
  const { t } = useTranslation();

  const work = t(`work.workItems.${projectId}`, { returnObjects: true });
  const imgSrc = projectImages[projectId];

  return (
    <div className='child-page-wrapper work-child-wrapper'>
      <h1>{t('work.h1')}</h1>
      <motion.div 
        variants={containerStagger}
        initial='hidden'
        whileInView='visible'
        viewport={{ once: true, amount: 0.4 }}
      >
        <motion.h2 
          className='work-project-title'
          variants={fadeUpOnView}
          >
          {work.title}
        </motion.h2>
        
        {imgSrc && (
          <motion.div 
          className='work-img'
          variants={fadeUpOnView}
          >
            <img 
              src={imgSrc} 
              alt=''
              role='presentation'
            />
          </motion.div>
        )}
        
        <motion.div 
          className='work-info-wrapper'
          variants={fadeUpOnView}
        >
          <div className='work-info-left'>
            <div className='work-info-inner'>
              <p>Release:</p>
              <span>{work.date}</span>
            </div>
            <div className='work-info-inner'>
              <p>Role:</p>
              <ul className='work-info-list'>
                {Array.isArray(work.tag) &&
                  work.tag.map((tag, i) => (
                    <li key={i} className='tech-tag'>{tag}</li>
                  ))}
              </ul>
            </div>

            <div className='work-info-inner'>
              <p>Tech stacks:</p>
              <ul className='work-info-list'>
                {Array.isArray(work.tech) &&
                  work.tech.map((tech, i) => (
                    <li key={i} className='tech-stack'>{tech}</li>
                  ))}
              </ul>
            </div>

          </div>
          <div className='work-info-right'>
            <p>{work.desc}</p>
            {work.link && (
              <a 
                href={work.link} 
                target='_blank' 
                rel='noopener noreferrer' 
                className='work-link'
              >
                {t('work.viewSite')}
                <FontAwesomeIcon icon={faArrowUpRightFromSquare} />
              </a>
            )}
          </div>
        </motion.div>
      </motion.div>
      <NavLink 
        className='back-button'
        to='/work'
        aria-label=''
      >
        <FontAwesomeIcon icon={faCircleLeft} />
        Back
      </NavLink>
    </div>
  );
}
